<!-- eslint-disable max-len -->
<style>
  .dialog-resource-name-and-formula {
    display: flex;
    flex-direction: column;
    @media (min-width: 800px) {
      flex-direction: row;
      gap: 20px;
    }
    > .v-text-field {
      margin-top: 10px;
      flex: 1 1 0;
    }
  }
</style>

<template>
  <div>
    <!--
    <v-card-title style="display: none;">
      {{ this.dialogConfig.title }}
      <v-btn
        icon
        outlined
        @click="onCancel"
        style="margin-left: auto;"
        color="grey"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
-->
    <v-card-text v-if="this.dialogConfig || this.dialogConfig.initialStep === 1">
      <div>
        <div class="dialog-resource-name-and-formula" style="align-items: baseline">
          <v-text-field
            data-testid="dialog_resource_add__edit_name_input"
            v-model="dialogConfig.resource.coreResource.name"
            :label="translate('dialog_input_resource_name')"
            required
            ref="resourceName"
            outlined
            dense
            background-color="white"
          ></v-text-field>

          <div style="display: flex; flex-direction: column; width: 40%; flex: 0;">

            <v-select
              v-if="formulasAvailable.length > 1"
              data-testid="dialog_resource_add__formula_select"
              :items="formulasAvailable"
              :label="translate(dialogConfig.resource.coreResource.rel === 'service' ? 'dialog_input_resource_formula_income' : 'dialog_input_resource_formula_expense')"
              v-model="dialogConfig.resource.flows[0].formula"
              item-text="name"
              item-value="id"
              return-object
              @change="onFormulaChange"
              outlined
              dense
              background-color="white"
            ></v-select>

            <v-text-field
              v-if="formulasAvailable.length === 1"
              label="Income Formula"
              v-model="dialogConfig.resource.flows[0].formula.name"
              readonly
              outlined
              dense
              background-color="white"
              style="margin-top: 7px;"
            ></v-text-field>
            <v-btn v-if="$store.state.user.settings.plan === 0 || isLocalHost" x-small @click="addFormula">add formula</v-btn>
          </div>
        </div>

        <v-card v-if="addingFormula" outlined style="padding: 10px;">
          <div style="display: flex; gap: 20px; align-items: baseline">
            <v-text-field
              label="New formula"
              v-model="newFormulaText"
              outlined
              dense
              background-color="white"
              style="margin-top: 7px;"
              @input="(value) => onFormulaExpressionChange(null, value)"
            ></v-text-field>
            <v-btn color="green" @click="saveNewFormula">Save</v-btn>
          </div>
          <!-- from DialogResourceAddFlow -->
          <div v-for="(variable, i) in newFormula.variables" :key="i">
            <div class="assumptions_item_container">
              <div style="color: #000; display: flex; flex-direction: column; align-items: start;">
                {{ translate(variable.name) }}
                <v-checkbox v-model="variable.isCurrency" dense label="Is currency?"></v-checkbox>
              </div>

              <v-text-field
                v-if="!variable.isCurrency"
                v-model="variable.units"
                required
                outlined
                dense
                background-color="white"
                hide-details
              ></v-text-field>
            </div>
          </div>
        </v-card>

        <div v-if="dialogFormula">

          <div v-if="$store.state.user.settings.plan === 0 || isLocalHost">
            <v-btn v-if="$store.state.user.settings.plan === 0 || isLocalHost" x-small @click="editFormula">edit formula</v-btn>
            <v-btn v-if="$store.state.user.settings.plan === 0 || isLocalHost" x-small @click="saveFormula">save formula</v-btn>

            <v-textarea
              rows="2"
              label="Current formula"
              v-model="dialogConfig.resource.flows[0].formula.expression"
              outlined
              dense
              background-color="white"
              style="margin-top: 7px;"
              @input="(value) => onFormulaExpressionChange(dialogConfig.resource.flows[0].formula, value)"
            ></v-textarea>
          </div>

          <DialogResourceAddFlow
            :flow="dialogConfig.resource.flows[0]"
            :flowIndex=0
            :updateAssumptions="updateAssumptions"
            :dialogConfig="dialogConfig"
            :dialogFormula="dialogFormula"
            :formulasAvailable="[]"
            :isEditingFormula="editingFormula"
          />
        </div>

        <div
          v-if="dialogConfig.resource.coreResource.rel === 'fixedasset'"
          style="display: flex; font-size: 16px;"
        >
          <div style="color: #000; width: 150px; margin-top: 20px;">
            {{ translate('ui_dialog_assumptions_deprgroup_selector') }}
          </div>
          <div style="width: 100px; margin-top: 20px; color: #000;"></div>
          <div style="margin-top: 7px; flex: 1 1 0;">
            <v-select
              data-testid="dialog_resource_add__depr_select"
              :items="depreciationGroups"
              :label="translate('ui_dialog_assumptions_deprgroup_selector')"
              v-model="dialogConfig.resource.otherAssumptions.deprgroup.lookupId"
              item-text="name"
              item-value="id"
              return-object
              @change="onDepreciationGroupChange"
              outlined
              dense
              background-color="white"
              hide-details
            ></v-select>

            <a
              data-testid="dialog_resource_add__add_depr_btn"
              style="text-decoration: underline; display: block; margin-top: 10px;"
              @click="(e) => this.addNewItem(e, 'deprgroup')"
            >
              {{ translate('ui_add_btn') }}
              {{ translate('ui_add_deprgroup_btn') }}
            </a>
          </div>
        </div>

        <div
          v-if="dialogConfig.resource.coreResource.rel === 'fixedasset'"
          style="display: flex; font-size: 16px; margin: 30px 0;"
        >
          <div style="color: #000; width: 150px; margin-top: 20px;">
            {{ translate('ui_dialog_assumptions_taxproperty_selector') }}
          </div>
          <div style="width: 100px; margin-top: 20px; color: #000;"></div>
          <div style="margin-top: 7px; flex: 1 1 0;">
            <v-select
              class="dialog_resource_add__property_tax_select"
              :items="propertyTaxes"
              :label="translate('ui_dialog_assumptions_taxproperty_selector')"
              v-model="dialogConfig.resource.otherAssumptions.taxproperty.lookupId"
              item-text="name"
              item-value="id"
              return-object
              @change="onPropertyTaxChange"
              outlined
              dense
              background-color="white"
              hide-details
            ></v-select>

            <a
              class="dialog_resource_add__add_property_tax_btn"
              style="text-decoration: underline; display: block; margin-top: 10px;"
              @click="(e) => this.addNewItem(e, 'taxproperty')"
            >
              {{ translate('ui_add_btn') }}
              {{ translate('ui_add_taxproperty_btn') }}
            </a>
          </div>
        </div>
      </div>

    </v-card-text>

    <TemplateDialogHintAssumptions
      :showTooltip="showTooltip"
      @closeDialogHintAssumptions="closeDialogHintAssumptions"
    />

    <v-dialog v-model="shouldShowDialogSimple" width="500">
      <div
        data-testid="dialog_resource_add__dialog_simple"
        class="section-settings-container__form"
      >
        <DialogResourceAddSimple
          :dialogConfig="dialogSimpleConfig"
        />
        <DialogToolbarBottom
          :resource="dialogSimpleConfig.resource"
          :section="dialogSimpleConfig.section"
          :tab="1"
          :onCancel="onCancelPropertyTax"
          :onSave="onSaveSimpleDialog"
        />
      </div>
    </v-dialog>

  </div>
</template>

<script>

import DialogResourceAddSimple
  from '@/components/dialogs/DialogResourceAdd/DialogResourceAddSimple';
import DialogToolbarBottom from '@/components/dialogs/DialogToolbarBottom';
import TemplateDialogHintAssumptions from './DialogResourceAddHintAssumptions.vue';
import DialogResourceAddFlow from './DialogResourceAddFlow.vue';

// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {
    DialogToolbarBottom,
    DialogResourceAddSimple,
    TemplateDialogHintAssumptions,
    DialogResourceAddFlow,
  },
  props: {
    cancel: Function,
    save: Function,
    saveAndAdd: Function,
    dialogConfig: Object,
    formulas: Array,
    dialogAssumptions: Array,
    showSuggestions: Boolean,
    className: String,
  },
  mixins: [Mixin],
  data() {
    return {
      radioGroupItems: ['Equity', 'Loan'],
      dialogFormula: {},
      e1: 1,
      showTooltip: false,
      dialogSimpleConfig: {},
      shouldShowDialogSimple: false,
      addingFormula: false,
      newFormulaText: 'total = foo + bar',
      newFormula: {},
      editingFormula: false,
    };
  },
  methods: {
    saveFormula() {
      const { formulas } = this.$store.state.activeTemplate.data;
      const formulaIndex = formulas.findIndex((f) => f.id === this.dialogConfig.resource.flows[0].formula.id);
      formulas.splice(formulaIndex, 0, this.dialogConfig.resource.flows[0].formula);
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.data.formulas',
        value: formulas,
      });
    },
    saveNewFormula() {
      const { formulas } = this.$store.state.activeTemplate.data;
      formulas.push(this.newFormula);
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.data.formulas',
        value: formulas,
      });
      // use this new formula for the current resource
      this.dialogConfig.resource.flows[0].formula = this.newFormula;
      this.onFormulaChange();
      this.addingFormula = false;
    },
    onFormulaExpressionChange(formula, value) {
      const expression = value.split('=')[1].trim();
      const operands = expression.split(/[()=+\-*/]+/);

      if (formula) {
        // editing
        // eslint-disable-next-line
        formula.variables = operands.reduce((arr, operand, index) => {
          // eslint-disable-next-line
          if (isNaN(operand)) {
            let result;
            if (formula.variables[index]) {
              result = formula.variables[index];
            } else {
              result = {
                id: this.uuidv4nodash(),
                name: operand,
                value: '0',
                units: 'units',
                isCurrency: false,
                _allowEdit: true,
              };
            }
            arr.push(result);
          }
          return arr;
        }, []);
        // remove extra fcst values if now has fewer variables
        this.dialogConfig.resource.flows.splice(formula.variables.length);
        // from mixin
        this.onFormulaChange();
      } else {
        // new formula
        // eslint-disable-next-line
        const variables = operands.reduce((arr, operand) => {
          // eslint-disable-next-line
          if (isNaN(operand)) {
            arr.push({
              id: this.uuidv4nodash(),
              name: operand,
              value: '0',
              units: 'units',
              isCurrency: false,
              _allowEdit: true,
            });
          }
          return arr;
        }, []);

        const formulaObj = {
          id: this.uuidv4nodash(),
          name: expression,
          subject: {
            header: 'formula_totalcaption',
          },
          expression: value,
          variables,
          allowedRels: [
            'service',
            'sga',
            'fixedasset',
          ],
          canEdit: true,
          hideUnits: false,
          showAssumptions: true,
        };
        this.newFormula = formulaObj;
        console.log(formulaObj);
      }
    },
    editFormula() {
      this.editingFormula = true;
    },
    addFormula() {
      this.addingFormula = true;
    },
    updateAssumptions(flowIndex, assumptionIndex, value) {
      this.onAssumptionsChange(flowIndex, assumptionIndex, value);
    },
    closeDialogHintAssumptions() {
      this.showTooltip = false;
    },
    addNewItem(event, rel) {
      const sectionId = rel === 'taxproperty' ? 'section_taxes' : 'section_depreciation';
      const sectionMacro = this.$store.state.activeTemplate.data.sections[2];
      const section = sectionMacro.sections.find((s) => s.id === sectionId);
      const resource = this.createNewSectionResource(section, rel);

      this.dialogSimpleConfig = {
        title: 'n/a',
        formulas: [],
        section,
        resource,
        onScrollDisabled: false,
      };
      this.shouldShowDialogSimple = true;

      // this.addResource(event, section, null, rel, simpleDialog);
    },
    onDepreciationGroupChange({ id }) {
      const sectionResource = this.dialogConfig.resource;
      sectionResource.otherAssumptions.deprgroup.lookupId = id;
    },
    onPropertyTaxChange({ id }) {
      const sectionResource = this.dialogConfig.resource;
      sectionResource.otherAssumptions.taxproperty.lookupId = id;
    },
    updateFlowAssumptions(value, index) {
      const flowIndex = 0;
      this.onAssumptionsChange(flowIndex, value, index);
    },
    onCancel() {
      this.e1 = 1;
      this.cancel();
    },
    onCancelPropertyTax() {
      this.shouldShowDialogSimple = false;
      // this.e1 = 1;
      // this.cancel();
    },
    onSaveSimpleDialog() {
      this.saveResource(this.dialogSimpleConfig);
      this.shouldShowDialogSimple = false;

      const sectionResource = this.dialogConfig.resource;
      if (this.dialogSimpleConfig.resource.coreResource.rel === 'taxproperty') {
        sectionResource.otherAssumptions.taxproperty.lookupId = this.dialogSimpleConfig.resource.id;
      } else {
        // depr
        sectionResource.otherAssumptions.deprgroup.lookupId = this.dialogSimpleConfig.resource.id;
      }
    },
    reset() {
      this.e1 = 1;
    },
  },
  computed: {
    isLocalHost() {
      return window.location.host.includes('localhost');
    },
    currencies() {
      // get currencies
      const sectionMacro = this.$store.state.activeTemplate.data.sections[2];
      const sectionCurrencies = sectionMacro.sections[0];
      return sectionCurrencies.sectionResources
        .map((sr) => sr.coreResource.name);
    },
    depreciationGroups() {
      const depreciationGroups = this.$store.state.activeTemplate.data.env.sectionResources.filter((sr) => sr.coreResource.rel === 'deprgroup');
      let depreciationGroupsOptions = [{
        id: null,
        name: this.translate('ui_dialog_assumptions_deprgroup_selector_nodeprgroup'),
      }];
      // eslint-disable-next-line
      depreciationGroupsOptions = depreciationGroupsOptions.concat(depreciationGroups.map((deprGroup) => {
        return {
          id: deprGroup.id,
          name: deprGroup.coreResource.name,
        };
      }));

      return depreciationGroupsOptions;
    },
    propertyTaxes() {
      const propertyTaxes = this.$store.state.activeTemplate.data.env.sectionResources.filter((sr) => sr.coreResource.rel === 'taxproperty');
      let propertyTaxesOptions = [{
        id: null,
        name: this.translate('ui_dialog_assumptions_taxproperty_selector_notaxproperty'),
      }];
      // eslint-disable-next-line
      propertyTaxesOptions = propertyTaxesOptions.concat(propertyTaxes.map((propertyTax) => {
        return {
          id: propertyTax.id,
          name: propertyTax.coreResource.name,
        };
      }));

      return propertyTaxesOptions;
    },
    selectedFinancingType: {
      get() {
        return this.dialogConfig.resource.coreResource.rel;
      },
      set(rel) {
        if (rel === 'loan') {
          this.dialogConfig.resource.otherAssumptions.interestmargin = {
            name: 'input_resource_options_interestmargin',
            value: null,
            units: '%',
          };
        } else {
          delete this.dialogConfig.resource.otherAssumptions.interestmargin;
        }
        this.dialogConfig.resource.coreResource.rel = rel;
        // eslint-disable-next-line
        const nextResourceIndex = this.dialogConfig.section.sectionResources.filter((r) => r.coreResource.rel === rel).length + 1;

        const resourceName = `New ${rel} ${nextResourceIndex}`;
        this.dialogConfig.resource.coreResource.name = resourceName;
      },
    },
    formulasAvailable() {
      const rel = this.selectedFinancingType;
      // eslint-disable-next-line
      const formulas = this.formulas.filter(f => {
        if (!f.allowedRels) {
          console.log('formula is broken', f);
        }
        return f.allowedRels && f.allowedRels.includes(rel);
      });
      return formulas;
    },
  },
  watch: {
    // eslint-disable-next-line
    initialStep: function (newValue) {
      if (newValue === -1) {
        this.reset();
      }
    },
  },
};
</script>
